/**
 * @module builder
 */
import type { MoveableItem } from '../../index'

export function filterOption(item: MoveableItem): boolean {
  return item.show && !item.use_total && !item.pending && !item.addedOption
}
